import React from 'react'

export const BlockquoteIcon: React.FC = () => (
  <svg
    aria-hidden="true"
    className="graphic blockquote-icon"
    fill="currentColor"
    focusable="false"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path className="fill" d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
)
